import { createListFilters, IOption } from 'app/components'

export type TelekitsFilters = {
  empresa?: IOption<number>
  situacao?: IOption<boolean>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<TelekitsFilters>({
  empresa: undefined,
  situacao: undefined,
})
